import PropTypes from 'prop-types';
import React from "react";

const SVG = ({
  style = {},
  fill = "#444",
  width = "100%",
  height = "100%",
  className = "",
  viewBox = "0 0 112 32"
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M48.171 31.994l1.37-9.936 8.285-18.193h-7.612l-3.146 9.119-.166-.023-.36-9.096h-7.623L41.9
      22.109l-1.365 9.884h7.635zM88.959 31.994l3.94-28.128h-6.818l-1.496 10.712h-.274L83.129 3.866h-7.195l-3.906
      28.128h7.229l1.336-9.542h.234l1.29 9.542h6.841zM107.814 31.994l-2.57-13.956 6.504-14.173h-7.612l-2.65
      7.098-.166-.023-.68-7.075h-7.623l2.575 14.196-6.504 13.933H96.7l2.604-6.938.166.023.719 6.915h7.623zM25.907
      32l1.142-8.291h1.142a24.875 24.875 0 004.535-.34l-.145.02a5.9 5.9 0 002.703-1.152l-.014.01a5.016 5.016 0 
      001.503-2.215l.01-.035c.355-1.042.643-2.273.811-3.542l.011-.101.731-5.139c.126-.82.197-1.766.197-2.728 
      0-.308-.007-.614-.022-.918l.002.043a3.529 3.529 0 00-.866-2.237l.004.004a4.405 4.405 0 00-2.374-1.168l-.025-.003a20.966 20.966 
      0 00-4.329-.342h.023l-8.782.057-3.883 28.088zm3.067-22.367h1.525a.68.68 0 01.542.205.899.899 0 01.124.749l.001-.006-.908 
      6.475a1.526 1.526 0 01-.266.713l.003-.005a.777.777 0 01-.626.211h.003-1.542zM58.29 31.903a4.554 4.554 0 002.669-1.029l-.008.006a5.772 
      5.772 0 001.544-2.666l.009-.04c.418-1.429.769-3.148.983-4.909l.016-.162 2.941-19.238h-7.515L55.811 24.25c-.108.691-.52.834-.845.834h-3.54l-.936 
      6.641 3.472.194c.885.051 1.713.08 2.421.08s1.359-.029 1.907-.097zM70.681 31.994l2.638-23.44H67.94l-4.768 23.44h7.509zM74.844 3.706a3.706 3.706 
      0 11-7.411 0 3.706 3.706 0 017.411 0zM10.929 3.923h-.057a19.158 19.158 0 00-3.453.219l.107-.014a5.923 5.923 0 00-2.727 1.153l.014-.011a4.731 
      4.731 0 00-1.526 2.143l-.01.033a19.992 19.992 0 00-.789 3.584l-.011.104-.274 2.147a8.37 8.37 0 00-.034 2.73l-.006-.046a4.047 4.047 0 002.001 
      2.845l.02.01c.508.257.976.52 1.645.788l2.187.851c.571.24 1.062.44 1.399.571.362.117.677.284.956.497l-.008-.006a.968.968 0 01.224.62l-.002.056v-.003c0 
      .251-.457 3.518-.457 3.518-.108.697-.44.857-.765.857H7.564l.508-3.826-6.224-2.427a.182.182 0 00-.245.142v.001L-.002 31.994H9.46a19.75 19.75 0 003.455-.219l-.109.014a5.923 
      5.923 0 002.727-1.153l-.014.011a4.716 4.716 0 001.503-2.137l.01-.033c.349-1.048.639-2.294.815-3.577l.013-.112.263-2.153a8.37 8.37 0 00.034-2.73l.006.046a4.012 4.012 0 
      00-2.001-2.845l-.02-.01c-.508-.251-.976-.52-1.645-.782l-2.187-.851a41.47 41.47 0 
      00-1.399-.571 3.406 3.406 0 01-.957-.498l.009.007a.993.993 0 01-.223-.63l.001-.034v.002c0-.246.457-3.512.457-3.512.108-.697.44-.857.771-.857h1.793l-.508 3.82 6.224 
      2.421a.177.177 0 00.246-.142v-.001l1.61-11.546z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string
};

export default SVG;
